// extracted by mini-css-extract-plugin
module.exports = {"order-address":"orderDetailsAddress_order-address__liNvF","section":"orderDetailsAddress_section__BLblm"};